import React, { useState } from "react";
import VotersChart from "./TotalVotersChart";

const allYearsData = {
  2016: [
    {
      Fields: "Constitution",
      "No. of Voters": "5,591",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "1,77,435",
    },

    {
      Fields: "Independent American",
      "No. of Voters": "23,071",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "13,317",
    },

    {
      Fields: "Republican",
      "No. of Voters": "7,24,478",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "2,983",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "6,14,526",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "15,58,418",
    },
  ],
  2017: [
    {
      Fields: "Constitution",
      "No. of Voters": "5,563",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "1,77,037",
    },
    {
      Fields: "Independent American",
      "No. of Voters": "23,127",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "13,302",
    },

    {
      Fields: "Republican",
      "No. of Voters": "7,22,834",
    },
    {
      Fields: "Unaffiliated",
      "No. of Voters": "6,12,986",
    },

    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "15,54,849",
    },
  ],
  2018: [
    {
      Fields: "Constitution",
      "No. of Voters": " 6,282",
    },
    {
      Fields: "Democratic",
      "No. of Voters": " 2,08,806 ",
    },
    {
      Fields: "Green",
      "No. of Voters": " 1,808 ",
    },
    {
      Fields: "Independent American",
      "No. of Voters": " 40,598 ",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": " 17,384 ",
    },

    {
      Fields: "Republican",
      "No. of Voters": " 7,62,487 ",
    },
    {
      Fields: "United Utah",
      "No. of Voters": " 1,493 ",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": " 6,18,063 ",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": " 16,56,921 ",
    },
  ],
  2019: [
    {
      Fields: "Constitution",
      "No. of Voters": "6687",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "219266",
    },
    {
      Fields: "Green",
      "No. of Voters": "2173",
    },
    {
      Fields: "Independent American",
      "No. of Voters": "50369",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "19402",
    },

    {
      Fields: "Republican",
      "No. of Voters": "768223",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "1849",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "622733",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "1690702",
    },
  ],
  // ...

  2020: [
    {
      Fields: "Constitution",
      "No. of Voters": "6686",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "219213",
    },
    {
      Fields: "Green",
      "No. of Voters": "2173",
    },

    {
      Fields: "Independent American",
      "No. of Voters": "50363",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "19399",
    },

    {
      Fields: "Republican",
      "No. of Voters": "768087",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "1849",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "622912",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "1690682",
    },
  ],

  2021: [
    {
      Fields: "Constitution",
      "No. of Voters": "7328",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "271977",
    },

    {
      Fields: "Independent American",
      "No. of Voters": "68116",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "22832",
    },

    {
      Fields: "Republican",
      "No. of Voters": "912895",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "2589",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "566208",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "1851945",
    },
  ],
  2022: [
    {
      Fields: "Constitution",
      "No. of Voters": "7845",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "271132",
    },

    {
      Fields: "Independent American",
      "No. of Voters": "75387",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "24676",
    },

    {
      Fields: "Republican",
      "No. of Voters": "962260",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "2775",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "567179",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "1911254",
    },
  ],
  2023: [
    {
      Fields: "Constitution",
      "No. of Voters": "8184",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "269850",
    },

    {
      Fields: "Independent American",
      "No. of Voters": "81167",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "25598",
    },
    {
      Fields: "No Labels",
      "No. of Voters": "976",
    },
    {
      Fields: "Republican",
      "No. of Voters": "963040",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "2971",
    },

    {
      Fields: "Unaffiliated",
      "No. of Voters": "576166",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "1927952",
    },
  ],
  2024: [
    {
      Fields: "Constitution",
      "No. of Voters": "8043",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "281196",
    },
    {
      Fields: "Green",
      "No. of Voters": "648",
    },
    {
      Fields: "Independent American",
      "No. of Voters": "88561",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "24135",
    },
    {
      Fields: "No Labels",
      "No. of Voters": "11044",
    },
    {
      Fields: "Republican",
      "No. of Voters": "1016247",
    },
    {
      Fields: "United Utah",
      "No. of Voters": "3003",
    },
    {
      Fields: "Utah Forward",
      "No. of Voters": "155",
    },
    {
      Fields: "Unaffiliated",
      "No. of Voters": "574538",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "2007570",
    },
  ],
  2025: [
    {
      Fields: "Constitution",
      "No. of Voters": "8,181",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "2,83,163",
    },
    {
      Fields: "Green",
      "No. of Voters": "797",
    },
    {
      Fields: "Independent American",
      "No. of Voters": "90,896",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "24,283",
    },
    {
      Fields: "No Labels",
      "No. of Voters": "11,210",
    },
    {
      Fields: "Republican",
      "No. of Voters": "10,23,326",
    },
    {
      Fields: "Forward",
      "No. of Voters": "3,000",
    },
    {
      Fields: "Unaffiliated",
      "No. of Voters": "5,88,813",
    },
    {
      Fields: "Total Active & Inactive Voters",
      "No. of Voters": "20,33,669",
    },
  ],
};

const TotalVoters = () => {
  const [selectedYear, setSelectedYear] = useState(2025);

  const handleYearChange = (e) => {
    setSelectedYear(Number(e.target.value));
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "96%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 style={{ color: "#CB0C0C", marginBottom: "20px" }}>
          Total Voters Chart - {selectedYear}
        </h1>

        <select
          value={selectedYear}
          onChange={handleYearChange}
          style={{
            marginBottom: "20px",
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
          }}
        >
          {Object.keys(allYearsData)
            .sort()
            .map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
        </select>
      </div>

      <div style={{ width: "100%", overflowX: "auto" }}>
        <div style={{ width: "100%", minWidth: "600px" }}>
          <VotersChart data={allYearsData[selectedYear]} />
        </div>
      </div>
    </div>
  );
};

export default TotalVoters;
